import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useReviewStatusCardStyles = makeStyles({
  card: {
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.rule}`,
    borderRadius: "14px",
    boxShadow: projectIqTokens.shadowSm,
    padding: `${designTokens.spacing[4]} 18px`,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    minWidth: 0,
  },
  label: {
    fontSize: "12.5px",
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.muted,
  },
  value: {
    fontSize: "15px",
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
